/**
 * Created by Ricardo Cabret on 4/11/2016.
 */

angular.module('eStories.catalog.model', [
    /*Catalog Model*/
]).service('CatalogModel', ['WS', 'LL', '$rootScope', '$location',
    function (WS, LL, $rootScope, $location) {

        /*TODO: separate library and recommendation end points to respective models*/
        /*Cached header covers*/
        this.authorHeaderCovers = null;
        this.narratorHeaderCovers = null;
        this.publisherHeaderCovers = null;
        this.landingSectionsMap = null;

        // noinspection JSUnusedGlobalSymbols
        this.discoverGenresList = [
            {name: "Mystery & Detective", url: "/genres/mystery_&_detective"},
            {name: "Science Fiction", url: "/genres/science_fiction"},
            {name: "Thrillers", url: "/genres/thrillers"},
            {name: "Fantasy", url: "/genres/fantasy"},
            {name: "Romance", url: "/genres/romance"},
            {name: "True Crime", url: "/genres/true_crime"},
            {name: "Fiction", url: "/genres/fiction"},
            {name: "Business & Economics", url: "/genres/business_&_economics"},
            {name: "Biography & Autobiography", url: "/genres/biography_&_autobiography"},
            {name: "Humor", url: "/genres/humor"},
            {name: "History", url: "/genres/history"},
            {name: "Nonfiction", url: "/genres/nonfiction"},
            {name: "Children & Young Adult", url: "/genres/children_&_young_adult_fiction"},
            {name: "Self-Help", url: "/genres/self-help"},
            {name: "More...", url: "/browse"},
        ];

        // noinspection JSUnusedGlobalSymbols
        this.discoverQuickLinks = [
            {
                name: 'New Releases',
                url: '/section/new_releases'
            },
            {
                name: 'Bestsellers',
                url: '/section/best_sellers'
            },
            {
                name: "Editors' Picks",
                url: '/section/editors_picks'
            },
            {
                name: 'Free Audiobooks',
                url: '/browse?onlyForFree'
            }
        ];

        this.getSimilar = (audiobookId, paginationObj) => {
            var getSimilarObj = {
                audiobookId: audiobookId,
                pagination: paginationObj ? paginationObj : getDefaultPagination(null, 2)
            };
            return WS.callServer('recommendation/similar', getSimilarObj);
        };

        /*Get Book Details Call*/
        this.getAudiobookDetails = (audiobookId) => {
            return WS.callServer('catalog/getAudiobook', {audiobookId: audiobookId});
        };

        this.getAudiobookByProviderId = (providerAudiobookId) => {
            return WS.callServer('catalog/getAudiobookByProviderId', {providerAudiobookId: providerAudiobookId});
        };

        /*Get Book Reviews Call*/
        this.getAudiobookReviews = (audiobookId) => {
            // Request Object
            const getAudiobookReviewsObj = {
                pagination: getDefaultPagination(),
                audiobookId: audiobookId
            };
            return WS.callServer('catalog/getAudiobookReviewList', getAudiobookReviewsObj);
        };

        /*Get ALL genres*/
        this.getFilterGenreList = () => WS.callServer('catalog/getFilterGenreList');

        /*Get subgenres*/
        this.getSubGenreList = (genreIdObj) => {
            return WS.callServer('catalog/getSubGenreList', genreIdObj);
        };

        /*Get All Audiobooks*/
        this.getAllAudiobooks = (filterObj, paginationObj, excludeAudiobookId) => {
            var pagination = paginationObj ? paginationObj : getDefaultPagination();
            var getAudiobooksObj = filterObj != null ? extend(filterObj, {pagination: pagination}) : {pagination: pagination};
            if (excludeAudiobookId) {
                getAudiobooksObj.excludeAudiobookId = excludeAudiobookId;
            }
            return WS.callServer('catalog/getAudiobookList', getAudiobooksObj);
        };

        this.getPublisher = (publisherId) => {
            return WS.callServer('catalog/getPublisher', {publisherId: publisherId});
        };

        this.getAuthor = (authorId) => {
            return WS.callServer('catalog/getAuthor', {authorId: authorId});
        };

        this.getNarrator = (narratorId) => {
            return WS.callServer('catalog/getNarrator', {narratorId: narratorId});
        };

        this.getSectionList = (sectionContextList) => {
            const getSectionListObj = {
                sectionContextList: sectionContextList ?
                    sectionContextList : ['LANDING_FEATURE_CAROUSEL', 'LANDING_SECTIONS', 'LANDING_FEATURE_DAILY_DEAL'],
                sectionPlatform: 'WEB'
            };
            return WS.callServer('catalog/getSectionList', getSectionListObj);
        };

        this.getSectionItemList = (requestObj) => {
            return WS.callServer('catalog/getSectionItemList', requestObj);
        };

        this.addToWishList = (audiobook) => {
            const tagObj = LL.convertAudiobookToLocalyticsObject(audiobook);
            tagObj['Type'] = 'ADD';
            LL.tagEvent('Change wishlist', tagObj);
            return WS.callServer('library/addToWishList', {audiobookId: audiobook.id});
        };

        this.deleteFromWishList = (audiobook) => {
            const tagObj = LL.convertAudiobookToLocalyticsObject(audiobook);
            tagObj['Type'] = 'DELETE';
            LL.tagEvent('Change wishlist', tagObj);
            return WS.callServer('library/deleteFromWishList', {wishListItemId: audiobook.wishListItemId});
        };

        this.getSectionByName = (sectionName) => {
            const getSectionObj = {sectionPlatform: 'WEB', sectionName: sectionName};
            return WS.callServer('catalog/getSectionByName', getSectionObj);
        };

        this.isPageNameLike = (pageName) => {
            return this.isPageNameInternal(pageName, true);
        };

        this.isPageName = (pageName) => {
            return this.isPageNameInternal(pageName, false);
        };

        this.isPageNameInternal = (pageName, useLike) => {
            const path = $location.path();
            const urlParts = path.split('/');
            const lastUrlPart = urlParts[urlParts.length - 1];
            if (useLike) {
                return lastUrlPart.toLowerCase().indexOf(pageName.toLowerCase()) > -1;
            } else {
                return pageName.toLowerCase() === lastUrlPart.toLowerCase();
            }
        };

    }]);

